var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupervisedLearning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#464F5D;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#BDC3C7;}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#65DDB9;}\r\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#3B97D3;}\r\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#FF5364;}\r\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#DF4D60;}\r\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#F0C419;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_05---Coding-Thinking"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "st0",
    d: "M42.6,23.4H65v43.1H42.6c-1.4,0-2.6-1.2-2.6-2.6V26C40,24.6,41.2,23.4,42.6,23.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    className: "st1",
    d: "M66.7,21.7v46.6c0,1-0.8,1.7-1.7,1.7l0,0c-1,0-1.7-0.8-1.7-1.7V21.7c0-1,0.8-1.7,1.7-1.7l0,0 C66,20,66.7,20.8,66.7,21.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Path_1_",
    className: "st2",
    d: "M43.4,32.9c-0.4,0-0.7-0.2-0.8-0.6c-0.1-0.4,0-0.7,0.3-1l2.5-1.9l-2.5-1.9 c-0.4-0.3-0.5-0.8-0.2-1.2s0.8-0.5,1.2-0.2l3.4,2.6c0.2,0.2,0.3,0.4,0.3,0.7s-0.1,0.5-0.3,0.7L44,32.8 C43.8,32.9,43.6,32.9,43.4,32.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2_",
    className: "st2",
    d: "M53.8,32.9h-3.4c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9h3.4c0.5,0,0.9,0.4,0.9,0.9 C54.7,32.5,54.3,32.9,53.8,32.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3_",
    className: "st2",
    d: "M46,38.1h-2.6c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9H46c0.5,0,0.9,0.4,0.9,0.9 C46.9,37.7,46.5,38.1,46,38.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4_",
    className: "st2",
    d: "M46,41.6h-2.6c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9H46c0.5,0,0.9,0.4,0.9,0.9 S46.5,41.6,46,41.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5_",
    className: "st2",
    d: "M46,45h-2.6c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9H46c0.5,0,0.9,0.4,0.9,0.9 C46.9,44.6,46.5,45,46,45z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6_",
    className: "st2",
    d: "M46,48.4h-2.6c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9H46c0.5,0,0.9,0.4,0.9,0.9 C46.9,48.1,46.5,48.4,46,48.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7_",
    className: "st2",
    d: "M46,51.9h-2.6c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9H46c0.5,0,0.9,0.4,0.9,0.9 C46.9,51.5,46.5,51.9,46,51.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8_",
    className: "st2",
    d: "M46,55.3h-2.6c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9H46c0.5,0,0.9,0.4,0.9,0.9 C46.9,55,46.5,55.3,46,55.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9_",
    className: "st2",
    d: "M46,58.8h-2.6c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9H46c0.5,0,0.9,0.4,0.9,0.9 S46.5,58.8,46,58.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10_",
    className: "st2",
    d: "M46,62.2h-2.6c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9H46c0.5,0,0.9,0.4,0.9,0.9 S46.5,62.2,46,62.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11_",
    className: "st2",
    d: "M59.8,38.1H49.5c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9h10.3c0.5,0,0.9,0.4,0.9,0.9 C60.7,37.7,60.3,38.1,59.8,38.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12_",
    className: "st2",
    d: "M58.1,41.6h-6.9c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9h6.9c0.5,0,0.9,0.4,0.9,0.9 S58.6,41.6,58.1,41.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13_",
    className: "st2",
    d: "M59.8,45H49.5c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9h10.3c0.5,0,0.9,0.4,0.9,0.9 C60.7,44.6,60.3,45,59.8,45z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14_",
    className: "st2",
    d: "M58.1,48.4h-6.9c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9h6.9c0.5,0,0.9,0.4,0.9,0.9 C59,48.1,58.6,48.4,58.1,48.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15_",
    className: "st2",
    d: "M59.8,51.9H49.5c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9h10.3c0.5,0,0.9,0.4,0.9,0.9 C60.7,51.5,60.3,51.9,59.8,51.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16_",
    className: "st2",
    d: "M58.1,55.3h-6.9c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9h6.9c0.5,0,0.9,0.4,0.9,0.9 C59,55,58.6,55.3,58.1,55.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17_",
    className: "st2",
    d: "M59.8,58.8H49.5c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9h10.3c0.5,0,0.9,0.4,0.9,0.9 S60.3,58.8,59.8,58.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18_",
    className: "st2",
    d: "M58.1,62.2h-6.9c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9h6.9c0.5,0,0.9,0.4,0.9,0.9 S58.6,62.2,58.1,62.2z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_19_",
    className: "st3",
    d: "M82.2,27.8h-7.3c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9h7.3c0.5,0,0.9-0.4,0.9-0.9 v-3.4c0-0.5,0.4-0.9,0.9-0.9c0.5,0,0.9,0.4,0.9,0.9v3.4C84.8,26.6,83.7,27.8,82.2,27.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20_",
    className: "st3",
    d: "M84,69.6c-0.5,0-0.9-0.4-0.9-0.9v-3.9c0-0.5-0.4-0.9-0.9-0.9h-5.2c-0.5,0-0.9-0.4-0.9-0.9 c0-0.5,0.4-0.9,0.9-0.9h5.2c1.4,0,2.6,1.2,2.6,2.6v3.9c0,0.2-0.1,0.4-0.3,0.6C84.4,69.5,84.2,69.6,84,69.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21_",
    className: "st3",
    d: "M88.3,64.8c-0.5,0-0.9-0.4-0.9-0.9v-2.6c0-0.5-0.4-0.9-0.9-0.9h-6c-0.5,0-0.9-0.4-0.9-0.9 c0-0.5,0.4-0.9,0.9-0.9h6c1.4,0,2.6,1.2,2.6,2.6V64C89.1,64.4,88.8,64.8,88.3,64.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22_",
    className: "st3",
    d: "M86.6,31.2h-8.9c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9h8.9c0.5,0,0.9-0.4,0.9-0.9v-3.1 c0-0.5,0.4-0.9,0.9-0.9c0.5,0,0.9,0.4,0.9,0.9v3.1C89.1,30,88,31.2,86.6,31.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23_",
    className: "st4",
    d: "M86,49.9c0.4,0.7,0.6,1.4,0.6,2.2c0,2.4-1.8,4.3-4.2,4.5c0.4,0.7,0.6,1.5,0.6,2.3 c0,1.3-0.5,2.6-1.5,3.5c-0.9,0.9-2.2,1.5-3.5,1.5c-1.1,2.6-3.8,4-6.6,3.5s-4.7-2.9-4.7-5.7V26.9c0,0,0-6.6,8.6-1.3 c0.7,0.4,1.5,0.9,2.3,1.5l0,0c0,0,0.1,0,0.1,0c1.6,0.6,2.6,2.1,2.6,3.8c0,0.2,0,0.3,0,0.5c-0.1,0.6-0.3,1.2-0.6,1.8c0,0,0,0,0,0 c2.9,0.1,5.2,2.5,5.2,5.4c0,0.5-0.1,1-0.2,1.4c1.2,1.1,1.9,2.6,2,4.2c0.1,1.6-0.6,3.2-1.7,4.3l0,0C85.3,48.9,85.7,49.4,86,49.9 L86,49.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24_",
    className: "st5",
    d: "M80.2,31.4c-0.1,0.6-0.3,1.2-0.6,1.8c-2.7,0.4-4.8,2.7-4.8,5.4c0,0.5-0.4,0.9-0.9,0.9 c-0.5,0-0.9-0.4-0.9-0.9C73.1,34.6,76.3,31.4,80.2,31.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25_",
    className: "st5",
    d: "M86,49.9c-1.5,1.2-3.4,1.8-5.3,1.8c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9 c1.5,0,3-0.5,4.2-1.4C85.3,48.9,85.7,49.4,86,49.9L86,49.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26_",
    className: "st5",
    d: "M77.7,27.2c-0.3-0.1-0.5-0.1-0.8-0.1c-2.1,0-3.9,1.7-3.9,3.9c0,0.5-0.4,0.9-0.9,0.9 s-0.9-0.4-0.9-0.9c0-2.5,1.6-4.7,4-5.4c0.7,0.4,1.5,0.9,2.3,1.5l0,0C77.6,27.1,77.6,27.1,77.7,27.2L77.7,27.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27_",
    className: "st5",
    d: "M79.3,48.4C79.3,48.4,79.3,48.4,79.3,48.4c0.6,0,0.9-0.4,1-0.8c0-0.5-0.3-0.9-0.8-0.9 c-1.2-0.1-2.2-0.9-2.6-2c3-0.7,5.2-3.4,5.2-6.5c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9c0,2-1.2,3.8-3.1,4.6 c-1.9,0.8-4,0.3-5.4-1.1c-0.3-0.3-0.9-0.3-1.2,0c-0.3,0.3-0.3,0.9,0,1.2c1.2,1.2,2.8,1.9,4.5,2C75.6,46.8,77.3,48.2,79.3,48.4 L79.3,48.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28_",
    className: "st5",
    d: "M79.3,56.6c-0.3,0-0.6,0-0.9,0.1c0,0,0-0.1,0-0.1c0-3.5-2.8-6.3-6.3-6.3 c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9c2.5,0,4.5,2,4.5,4.5c0,0.2,0,0.4-0.1,0.7c-2.2,1-3.5,3.2-3.5,5.6 c0,0.5,0.4,0.9,0.9,0.9s0.9-0.4,0.9-0.9c0-2.5,2-4.5,4.5-4.5c0.5,0,0.9-0.4,0.9-0.9S79.8,56.6,79.3,56.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29_",
    className: "st5",
    d: "M69.4,37.7c0,0.5-0.4,0.9-0.9,0.9c-1,0-1.8,0.8-1.8,1.8v-3c0.6-0.3,1.2-0.5,1.8-0.5 C69,36.8,69.4,37.2,69.4,37.7L69.4,37.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30_",
    className: "st5",
    d: "M72.6,55.7c0,0.5-0.4,0.9-0.9,0.9c-2.8,0-5,2.2-5,5v-4.5c1.3-1.4,3.1-2.2,5-2.2 C72.2,54.8,72.6,55.2,72.6,55.7L72.6,55.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    className: "st6",
    cx: 84,
    cy: 21.7,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_1_",
    className: "st6",
    cx: 88.3,
    cy: 26,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_2_",
    className: "st6",
    cx: 84,
    cy: 68.3,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_3_",
    className: "st6",
    cx: 88.3,
    cy: 64,
    r: 1.7
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupervisedLearning);
export default __webpack_public_path__ + "static/media/SupervisedLearning.4c6b95e161d4d04cdf392c70a2caf1b3.svg";
export { ForwardRef as ReactComponent };